import { CloseIcon } from './CloseIcon';

/**
 * author: Google
 * id FEA26660-7D6A-4C2A-9F13-7AE125FBA543
 * name close
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close.svg
 * tags
 * - Math 
 * - Form 
 */
export const RemoveIcon = CloseIcon;
export default RemoveIcon